export const formatEuroCents = (cents) => {
  const euros = Math.floor(cents / 100);
  const remainingCents = Math.abs(cents % 100);

  return `${euros},${remainingCents.toString().padStart(2, "0")}€`;
};
